import React from 'react'
import classNames from 'classnames'
import { EyebrowProps } from './Eyebrow.d'

// Component's Render Function with Props
const Eyebrow = ({
  icon,
  link,
  variation,
  children,
  content,
  componentClass
}: EyebrowProps) => {
  const styleClasses = classRules(variation, componentClass)
  const childrenProp = children || content

  const iconClasses = classNames('inline-block', {
    'mr-[6px]': variation === 'otl-grey',
    'mr-2': variation !== 'otl-grey' && variation !== 'pos-hp',
    'mr-1': variation === 'pos-hp'
  })

  return (
    <div className={styleClasses} data-testid='mds-eyebrow'>
      {icon?.src && (
        <img
          alt='icon'
          className={iconClasses}
          data-testid='mds-eyebrow-icon'
          height={icon.height}
          src={icon.src}
          title={variation}
          width={icon.width}
        />
      )}
      {link?.url ? (
        <a href={link.url} target={link.target} rel={link.rel}>
          {' '}
          {childrenProp}{' '}
        </a>
      ) : (
        <> {childrenProp} </>
      )}
    </div>
  )
}

// Create ClassName Object for Styles
const classRules = (variation: string, componentClass?: string) =>
  classNames(componentClass, {
    // test style class
    'inline-flex items-center': variation !== 'otl-related-articles',
    // Styles for otl-grey
    'font-calibre font-normal leading-none tracking-[1.2px] uppercase text-[12px] text-legacy-grey-10 mb-[16px]':
      variation === 'otl-grey',
    'font-sansPro font-semibold leading-none tracking-[1.2px] uppercase text-[12px] text-black mb-[8px]':
      variation === 'otl-black',
    'flex self-start font-sansPro font-semibold leading-none tracking-[1.2px] uppercase text-[12px] text-black mb-[8px]':
      variation === 'otl-related-articles',
    // Styles for otl-orange
    'font-calibre text-otl-topic-label uppercase text-xs text-brand-50 text-toast-orange-500 hover:otl-orange':
      variation === 'otl-orange',
    'mb-4 font-sansPro font-normal text-default text-xs uppercase leading-none tracking-[1.2px]':
      variation === 'ds',
    'mb-2 font-sansPro font-normal text-secondary text-xs':
      variation === 'secondary',
    'mb-2 font-sansPro font-normal text-secondary text-[16px] leading-[100%]':
      variation === 'pos-hp'
  })

// Export Render Function
export default Eyebrow
